var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.target
    ? _c(
        "div",
        {
          staticClass: "bl-target-details-panel",
          style: {
            height: !_vm.normalizedTaskTarget
              ? "calc(100% - 3rem)"
              : _vm.targetTab === "details"
              ? "auto"
              : "calc(100% - 3rem)"
          },
          attrs: { id: "target-property" }
        },
        [
          _c("div", { staticClass: "bl-target-details-tabs" }, [
            _c(
              "div",
              {
                staticClass: "bl-target-details-tab",
                class:
                  _vm.targetTab === "details"
                    ? "bl-target-details-tab-active"
                    : "",
                on: {
                  click: function($event) {
                    _vm.targetTab = "details"
                  }
                }
              },
              [
                _c("BlTextSubtitle2", { attrs: { text: "Details & settings" } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bl-target-details-tab",
                class:
                  _vm.targetTab === "progress"
                    ? "bl-target-details-tab-active"
                    : "",
                on: {
                  click: function($event) {
                    _vm.targetTab = "progress"
                  }
                }
              },
              [
                _c("BlTextSubtitle2", {
                  attrs: { text: "Progress & records" }
                }),
                _vm._v(" "),
                !_vm.readonly
                  ? _c("BlBubbleCount", {
                      attrs: {
                        count: _vm.entries.filter(function(i) {
                          return !i.type.includes("PhaseLine")
                        }).length
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.target.type === "Target::Sbt" && !_vm.normalizedTaskTarget
              ? _c(
                  "div",
                  {
                    staticClass: "bl-target-details-tab",
                    class:
                      _vm.targetTab === "problem_behaviors"
                        ? "bl-target-details-tab-active"
                        : "",
                    on: {
                      click: function($event) {
                        _vm.targetTab = "problem_behaviors"
                      }
                    }
                  },
                  [
                    _c("BlTextSubtitle2", {
                      attrs: { text: "Problem behaviors" }
                    }),
                    _vm._v(" "),
                    !_vm.readonly
                      ? _c("BlBubbleCount", {
                          attrs: {
                            count: _vm.entries.filter(function(i) {
                              return !i.type.includes("PhaseLine")
                            }).length
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.showRecommendation
            ? _c(
                "div",
                {
                  staticClass:
                    "sticky top-0 flex items-center justify-between gap-2 px-6 py-2 bg-orange-200"
                },
                [
                  _c("div", { staticClass: "flex items-center gap-2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "p-2 bg-orange-300",
                        style: { borderRadius: "4px" }
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "tooltip" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.ShowCloseRecommendationText
                      ? _c(
                          "div",
                          { staticClass: "flex flex-wrap items-center gap-1" },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-orange-800",
                              attrs: {
                                text:
                                  "You can still view recommendations in the"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold text-orange-800",
                              attrs: { text: "Recommendations" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-orange-800",
                              attrs: { text: "tab." }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "flex flex-wrap items-center gap-1" },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-orange-800",
                              attrs: { text: "This target has" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold text-orange-800",
                              attrs: {
                                text:
                                  _vm.target.total_success +
                                  " successful session(s)"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-orange-800",
                              attrs: { text: "with" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold text-orange-800",
                              attrs: {
                                text:
                                  _vm.target.consecutive_success +
                                  " consecutive success."
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-orange-800",
                              attrs: {
                                text: "Do you want to update the status to"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold text-orange-800",
                              attrs: { text: "'Mastered'?" }
                            })
                          ],
                          1
                        )
                  ]),
                  _vm._v(" "),
                  !_vm.ShowCloseRecommendationText
                    ? _c(
                        "div",
                        { staticClass: "flex items-center gap-2" },
                        [
                          _c("BlInputButton", {
                            attrs: {
                              label: "Accept",
                              type: "orange",
                              dense: "",
                              loading: _vm.acceptLoading
                            },
                            on: { clicked: _vm.onAcceptRecommendation }
                          }),
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass: "flex-shrink-0 w-6 h-6",
                            attrs: {
                              icon: "close",
                              color: "orange-6",
                              clickable: ""
                            },
                            on: { clicked: _vm.onCloseRecommendation }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.targetTab === "details" && !_vm.normalizedTaskTarget
            ? _c("TargetPropertyDetails", {
                attrs: { target: _vm.target, readonly: _vm.readonly }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.targetTab === "details" && _vm.normalizedTaskTarget
            ? _c("TaskPropertyDetails", {
                attrs: {
                  task: _vm.taskTarget,
                  target: _vm.target,
                  readonly: _vm.readonly
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.targetTab === "progress"
            ? _c("TargetPropertyProgress", {
                attrs: {
                  target: _vm.target,
                  entries: _vm.entries,
                  taskTarget: _vm.normalizedTaskTarget,
                  graphEntries: _vm.graphEntries,
                  readonly: _vm.readonly
                },
                on: {
                  "update:taskTarget": function($event) {
                    _vm.normalizedTaskTarget = $event
                  },
                  "update:task-target": function($event) {
                    _vm.normalizedTaskTarget = $event
                  },
                  updateTaskTarget: _vm.updateTaskTarget,
                  "select-task": _vm.selectTask
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.targetTab === "problem_behaviors"
            ? _c("TargetProblemBehaviors", {
                attrs: {
                  target: _vm.target,
                  entries: _vm.entries,
                  graphEntries: _vm.graphEntries,
                  readonly: _vm.readonly
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dfbe4a68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfbe4a68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/Property.vue
// module id = null
// module chunks = 